import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CurrentUser } from './currentUser.service';
import { User } from '../interfaces/user';
import { FacebookService } from './facebook.service';
import { FirebaseService } from './firebase.service';

@Injectable()
export class UserAccount {
  private baseUrl = environment.API;
  public data = new User();


  constructor(
    private http: HttpClient,
    private currentUser: CurrentUser,
    private facebookService: FacebookService,
    private firebaseService: FirebaseService
  ) {
    this.get();
  }

  public get() {
    if (this.currentUser.getJwtToken()) {
      const url = `${this.baseUrl}/users/account/`;
      this.http.get(url).subscribe((data: User) => {
        this.data = new User(data);
        if (this.facebookService.appId && !this.facebookService.getUserId()) {
          this.facebookService.setUserId(this.data.id);
        }
        if (this.firebaseService.appId && !this.firebaseService.getUserId()) {
          this.firebaseService.setUserId(this.data.id);
        }
      });
    }
  }

  public clear() {
    this.data = new User();
  }

  public set(data) {
    this.data = { ...this.data, ...data };
  }
}
